import MainLayout from 'components/layouts/MainLayout';
import { getMembershipMember } from 'features/membership/api';
import { NOW_LOADING } from 'libs/constants';
import {
  membershipMemberResponseAtom,
  tenantConfigurationAtom
} from 'libs/recoil/atom';
import { FC, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';

/**
 * スマートレシート用ページのアクセスチェック
 *
 * 会員連携済み & スマレシ有効であれば通過。
 * スマレシ連携・未連携状態は見ない。
 * なお「既存会員ポイントカード登録API」は、すでに連携済みでも冪等で実行できるAPIになっているので、連携フォームを進んでも問題ない。
 *
 * @see https://github.com/remix-run/react-router/blob/dev/examples/auth/src/App.tsx
 */
export const AccessVerifier: FC = () => {
  const [membershipMemberResponse, setMembershipMemberResponse] =
    useRecoilState(membershipMemberResponseAtom);
  const tenantConfig = useRecoilValue(tenantConfigurationAtom);

  useEffect(() => {
    // 未取得であれば会員情報照会APIを実行する
    if (!membershipMemberResponse) {
      getMembershipMember().then((res) => setMembershipMemberResponse(res));
    }
  }, [membershipMemberResponse, setMembershipMemberResponse]);

  if (!membershipMemberResponse || !tenantConfig) {
    return <MainLayout pageTitle={NOW_LOADING} isLoading />;
  }

  if (
    membershipMemberResponse.status !== 'succeeded' ||
    !tenantConfig.smart_receipt?.enabled
  ) {
    return <Navigate to="/not-found" />;
  }

  return <Outlet />;
};
